import { Head } from "@inertiajs/react"
import ProductionHeader from "@/components/admin/production/ProductionHeader"
import AssetForm from "@/components/admin/production/AssetForm"
import type { SharedProductionProps } from "@/components/admin/production/types"

interface AssetDetail {
  id: number
  label: string
  asset_kind: string | null
  purchase_cost_cents: number
  purchased_on: string | null
  notes: string | null
}

interface EditProps extends SharedProductionProps {
  asset: AssetDetail
  errors?: Record<string, string[]>
}

export default function AssetEdit({ store, paths, asset, errors }: EditProps) {
  return (
    <>
      <Head title={`Éditer ${asset.label}`} />
      <ProductionHeader
        title={`Éditer ${asset.label}`}
        storeName={store.name ?? undefined}
        paths={paths}
      />
      <main className="mx-auto max-w-4xl px-6 py-8">
        <AssetForm
          initial={{
            label: asset.label,
            asset_kind: asset.asset_kind ?? "",
            purchase_cost_cents: asset.purchase_cost_cents,
            purchased_on: asset.purchased_on ?? "",
            notes: asset.notes ?? "",
          }}
          submitUrl={`${paths.assets_index}/${asset.id}`}
          method="patch"
          errors={errors}
          cancelUrl={paths.assets_index}
        />
      </main>
    </>
  )
}
